var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -1.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3L4.5 9v21a3 3 0 0 0 3 3h21a3 3 0 0 0 3-3V9L27 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9h27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 15a6 6 0 0 1-12 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherShoppingBag);
export default __webpack_public_path__ + "static/media/icon-feather-shopping-bag.dfbd44749ee3e57cb2e9b8e1d7dd66a4.svg";
export { ForwardRef as ReactComponent };